import React from "react";
import { NavLink } from "react-router-dom";
import Empty from "../../assets/images/appImages/category.png";
import { getImage } from "../../utils/Utils";
import { getCardPriceDisplay, isProductAvailable } from "../../utils/productPricing";
import { useGetVendeurByApiKeyQuery } from "../../utils/api/product/product.api";
import { VendeurApikey } from "../../utils/http";

interface ProductNatureCardProps {
  item: any;
}

export const ProductNatureCard: React.FC<ProductNatureCardProps> = ({
  item,
}) => {
  const { data: vendeur } = useGetVendeurByApiKeyQuery(VendeurApikey);
  const Vendeur = vendeur || { devise: "XOF" };

  const imgProd =
    item?.type === "taille_unique"
      ? item?.images?.[0]?.image
      : item?.variations?.[0]?.images?.[0]?.image ?? null;

  const category =
    item?.sous_categorie?.nom ?? item?.categorie?.nom ?? "Produit naturel";

  const priceDisplay = getCardPriceDisplay(item, Vendeur?.devise);

  const available = isProductAvailable(item);

  return (
    <div className="product-nature-card">
      <div className="product-nature-card-image-wrapper">
        {item?.populaire && (
          <div className="product-nature-card-badge">POPULAIRE</div>
        )}

        <img
          loading="lazy"
          src={imgProd ? getImage(imgProd) : Empty}
          alt={item?.nom ?? ""}
          className="product-nature-card-image"
        />

        <NavLink
          to={`/produit/${item?.slug}`}
          state={item}
          className="product-nature-card-image-overlay"
          aria-label={item?.nom}
        />
      </div>

      <div className="product-nature-card-body">
        <p className="product-nature-card-category">
          {category.toUpperCase()}
        </p>

        <h4 className="product-nature-card-name">{item?.nom}</h4>

        <div className="product-nature-card-meta">
          <div className="product-nature-card-price-block">
            <span className="product-nature-card-price">
              {priceDisplay.display}
            </span>
            {priceDisplay.displayMru && (
              <span className="product-nature-card-price-mru">
                {priceDisplay.displayMru}
              </span>
            )}
          </div>
          <span
            className={`product-nature-card-status ${
              available
                ? "product-nature-card-status--available"
                : "product-nature-card-status--unavailable"
            }`}
          >
            {available ? "Disponible" : "Indisponible"}
          </span>
        </div>
      </div>

      <div className="product-nature-card-button-wrapper">
        <NavLink
          to={`/produit/${item?.slug}`}
          state={item}
          className="product-nature-card-button"
        >
          Voir le produit
        </NavLink>
      </div>
    </div>
  );
};

export default ProductNatureCard;